import { preparePayloadForGraphQL } from '@/helpers/validate';

/**
 * Fields of `investmentDeductionAllowance` saved by the block project-plant-data ("Anlagedaten")
 * with their payload type (`preparePayloadForGraphQL`). Must match `ProjectPlantDataInput`.
 */
const PROJECT_PLANT_DATA_FIELD_TYPES = {
  installationType: 'string',
  areaInSquareMeters: 'number',
  specificAnnualYieldKwhPerKwp: 'number',
  initialFeedInTariffDurationYears: 'number',
  feedInTariffGuaranteeCaseEurPerKwh: 'number',
  feedInTariffMedianCaseEurPerKwh: 'number',
  feedInTariffOptimalCaseEurPerKwh: 'number',
  expectedFeedInTariffIncreasePercentPerYear: 'number',
  degradationPercentPerYear: 'number',
  annualOperatingCostPerKwpEur: 'number',
  annualLeaseType: 'string',
  annualLeasePercent: 'number',
};

export const PROJECT_PLANT_DATA_INPUT_FIELDS = Object.keys(PROJECT_PLANT_DATA_FIELD_TYPES);

/**
 * `ProjectPlantDataInput` from the block object (or the unsaved project): the twelve fields of
 * `investmentDeductionAllowance`.
 */
export const toProjectPlantDataInput = (project) =>
  preparePayloadForGraphQL(
    project.investmentDeductionAllowance ?? {},
    PROJECT_PLANT_DATA_FIELD_TYPES
  );
